module.exports = __webpack_public_path__ + "img/logo.82e284cb.png";